import FingerprintJS from "@fingerprintjs/fingerprintjs";

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load();
const getFingerprint = async () => {
  const fp = await fpPromise;
  return await fp.get();
};

const getClientIpAddress = async () => {
  const resp = await fetch("https://ipapi.co/json")
    .then((res) => res.json())
    .catch((error) => console.log(error));
  return resp;
};

export { getFingerprint, getClientIpAddress };
